import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-cap-2-icon',
  templateUrl: './design-cap-2.component.html'
})
export class DesignCap2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
